module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch7",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('h1', {
    staticClass: "CN",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "42",
      "id": "pg_42",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAPANESE MODULE (JPM)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Carefully grasping the wrenches and screwdriver, Kimberly flew out of the JPM. Once in Node 2, she took a hard right and headed for the opposite end of the station by grabbing the hatchway’s inner handrail, changing her linear momentum to angular. The Klaxon still wailed throughout the ISS, and as she rounded the corner she didn’t see anything at the far Russian end. Her field of view to the Russian SM module, roughly a hundred yards away, was constricted by both the size of each successive module’s hatch, as well as her path as she propelled herself to the aft side of the ISS.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She soared into the U.S. lab, taking care not to hit the metal vestibule opening. Holding the makeshift weapons in front of her, she exited the aft end of the lab within seconds and thrust her hands down, causing her legs to rotate in the opposite direction. As she passed into Node 1 she kicked out, hitting the vestibule, which shot her toward the Joint Airlock entrance, like banking a pool ball off the side of the table.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She flew into the airlock, where Alexi Lashin and Viktor Oloff, the two remaining Russian cosmonauts, and Robert Stafford, "), _c('span', {
    attrs: {
      "aria-label": "43",
      "id": "pg_43",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("her American colleague, had been preparing the EVA suits. They quickly grabbed handholds and pulled themselves out of her way as she zoomed in. Careful not to hit her wrenches or screwdriver, Stafford reached out and clutched her by the arm as she shot by, twirling her around and stopping her in the middle of the module instead of allowing her to whiz past and crash into the hatch.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("One of the bulky EVA suits was rocking in its cradle, looking as though someone had been in the process of donning it. Four of the three dozen RTGs stored in MRM-1 were lashed together, floating near the outside hatch. Oloff swam to the vestibule and poked his head out, looking down the long series of interconnecting modules.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Get back in here,” Kimberly snapped. “Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Viktor jerked his head back inside the Joint Airlock. Pushing against the metal vestibule edge, he slowly floated back into the module and twisted around to look at her, his darkly stubbled face looking puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Robert’s pale blue eyes were also perplexed as he steadied her. “What’s going on? We heard the alarm—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You weren’t watching the docking?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hanging upside down relative to Kimberly, Alexi shook his shaved head. “"), _c('i', [_vm._v("Nyet.")]), _vm._v(" We were helping Robert into his suit. We’re moving the RTGs outside the station.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Here.” Kimberly shoved the tools at the three men. With quizzical looks on their faces they took the makeshift weapons, but instead of peppering her with questions, their cosmonaut and astronaut training kicked into high gear and they waited for Kimberly to explain, understanding that instead of wasting time asking questions, Kimberly would quickly bring them up to speed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She glided to the module’s vestibule, which opened to Node 1, and peeked outside. Quickly pulling back, she spoke in a hurried half whisper, briefing them on what had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "44",
      "id": "pg_44",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“They killed Colonel Zel’dovich?” Alexi asked, his voice half an octave higher than normal.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kimberly nodded. “And Al. And Ivan.” Something inside her wanted to break down and cry, but Kimberly pushed the possibility aside. Not now. Not ever. At least not ’til we get the bastards.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His face grim, Alexi gripped the wrench like a battle-ax and pushed off for the exit leading to Node 1.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Alexi, stop!” Kimberly ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He ignored her. He kept going until Viktor grabbed him by the foot. Alexi tried to shake off his grip, but he rotated toward the hatch. Turning, he glared at Kimberly, his face white with fury.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We cannot allow those mad dogs to live,” Alexi said. “I will stop them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, not alone,” said Kimberly. “You didn’t see them. They’re too well trained, extremely coordinated.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The new one is tourist and unable to function in zero-gee. I kill him first.” Alexi was built like a weight lifter, his chest and arms bulging inside his flight suit.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And if you fail?” Kimberly challenged.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I will not fail,” Alexi muttered. He turned to go.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Viktor said, “Listen to Kimberly. You are right, comrade, but "), _c('i', [_vm._v("we")]), _vm._v(" will stop them, not just you. We work together.” Turning to Kimberly, he asked, “You have plan?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, I do.” She moved up so she could keep an eye out the exit, to detect the intruders if they tried to surprise them. “They’ve cut off the comm links with Earth, so I imagine whatever they have planned, they’re going to see it to the finish. Like I said, they looked well trained, so we’ll have to surprise them, catch them off guard so we can stop them before they reach their goal, whatever it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "45",
      "id": "pg_45",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“You mean we ambush them and then kill them,” said Viktor. “So we hide.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s right,” Kimberly agreed. “Viktor, you and Alexi wait in Node 3, then rush out together to surprise them. Robert, you hit them from the side, coming from here. I may be the smallest on board, but I’m faster than any of you. I can draw them out, make them chase me to Node 1.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Robert followed her gaze out the exit and frowned. “But what if they catch up with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They won’t. I’ll make sure of that. Farid’s still getting his space legs back, and like Alexi said, the new guy, Bakhet, the Qatari tourist—he’s still fumbling around, although that doesn’t make them any less dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Viktor asked, “So how will you do it? What you say, ‘Draw them out’?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I bet they’re moving from aft to bow,” Kimberly replied. “Probably methodically searching the entire ISS, hunting us down, module by module. Which means they’ll be searching as a pair. So I’ll start working my way aft, down by the SM module. When they spot me I’ll shoot back here, toward Node 2. But I’ll stop in the U.S. lab and incite them. When they enter Node 1 that’s your signal to converge and spring the ambush.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And kill them,” Alexi said grimly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kimberly raised an eyebrow. “It would be nice to be able to question at least one of them, find out what they have in mind or if they’re just insane.” She hesitated. “But yes, after seeing what they’ve already done, I think our top priority is not just stopping them, but killing them.” She looked around. “Any questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The three men shook their heads.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“All right, let’s go. Be sure to hide in your respective modules. As soon as they’re in Node 1, go for it. I’ll try to yell when they’re "), _c('span', {
    attrs: {
      "aria-label": "46",
      "id": "pg_46",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("there, but don’t wait for me if you see them. I may not be able to give you a signal—I may be trying to survive myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Right.” The two Russians pushed off, Alexi and Viktor across the module, to Node 3.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kimberly waited until they were out of sight, then started out. Robert grabbed her arm. “Good luck, kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Following Kimberly to the hatch, Robert said, “Basher was serving as CAPCOM. Does he know what’s going on up here?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He must have seen what I saw on the monitor, so hopefully he dropped NASA TV’s feed to the public; but one of those murderers must have cut our comm to Earth. So Scott probably doesn’t know we’re still alive. "), _c('i', [_vm._v("No one")]), _vm._v(" may know.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So if we don’t succeed, then as far as NASA’s concerned we were taken out when those guys docked.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah.” Kimberly wanted to get started for the SM module, but Robert still clutched her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He asked, “If we don’t get them—if they kill us instead—what do you think those guys will do next?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t know,” Kimberly said as she pulled free of Robert’s hand and started aft. “Maybe they’ll just kill themselves; maybe this is some sort of twisted suicide mission. In any case, let’s not let them get that far.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578e5868","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 93
// module chunks = 0